export const USER_ROLES = {
  STUDENT: "STUDENT",
  EMPLOYEE: "EMPLOYEE",
  STAFF: "STAFF",
  ADMIN: "ADMIN",
  SOFTWARE_DEV: "SOFTWARE_DEV",
};

// Authorized roles for login on the portal.
export const AUTHORIZED_LOGIN_USER_ROLES = {
  EMPLOYEE: USER_ROLES.EMPLOYEE,
  STAFF: USER_ROLES.STAFF,
  ADMIN: USER_ROLES.ADMIN,
  SOFTWARE_DEV: USER_ROLES.SOFTWARE_DEV,
};

// Authorized roles for the settings page.
export const AUTHORIZED_SETTINGS_USER_ROLES = {
  STAFF: USER_ROLES.STAFF,
  ADMIN: USER_ROLES.ADMIN,
  SOFTWARE_DEV: USER_ROLES.SOFTWARE_DEV,
};

// Roles that can be changed by a role.
const STAFF = [USER_ROLES.EMPLOYEE, USER_ROLES.STAFF];
const ADMIN = [...STAFF, USER_ROLES.ADMIN];
const SOFTWARE_DEV = [...ADMIN, USER_ROLES.SOFTWARE_DEV];

export const AUTHORIZED_ALTER_TEACHER_ROLE = {
  STAFF,
  ADMIN,
  SOFTWARE_DEV,
};
